<template>
	<div id="srd">
			<div id="sup">
				<h1 >{{msg}}</h1>
			</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			msg: 'SUP',
		}
	},
	methods:{
		
	}
}
</script>

<style>
h1{
	color:aqua;
	font-size: 11em;
}
#srd{
	height: 100%;
	/* width: 100%; */
	background-color: gold;
}
#srd{

}
#srd #sup{
	
}
</style>
